import { render } from "./InterfaceDialogContainer.vue?vue&type=template&id=2b60d8a0&scoped=true"
import script from "./InterfaceDialogContainer.vue?vue&type=script&lang=js"
export * from "./InterfaceDialogContainer.vue?vue&type=script&lang=js"

import "./InterfaceDialogContainer.vue?vue&type=style&index=0&id=2b60d8a0&scoped=true&lang=scss"

import exportComponent from "/tmp/5ea1362f-94e3-43d0-86d7-afc144980eef/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b60d8a0"]])

export default __exports__